import React from 'react'

import clsx from 'clsx'

import Avatar from 'components/Avatar'
import Icon from 'components/Icon'

import classes from './ProfileAvatar.module.scss'

/** @type {import('./types').default} */
const ProfileAvatar = ({ className, ...avatarProps }) => {
  return (
    <Avatar className={clsx('ProfileAvatar', classes.root, className)} variant="rounded" {...avatarProps}>
      <Icon data-testid="defaultAvatar" icon="user" size="24" />
    </Avatar>
  )
}

export default ProfileAvatar
